
export const services = [
    // {
    //     title : 'Real Estate',
    //     nick_title : 'realEstate',
    //     category :[],
    //     content : 'S. S. Civil Construction Pvt. Ltd. (formerly S. S. Construction)was founded in 1984 as contracting company in Civil Construction and Structural Engineering. Some of the most outstanding projects we have executed are Construction of Water Treatment Plant at Chitpur for Eastern Railway; Construction of Kolkata Station Building and its Circulating .',
    //     photos : [
    //         {
    //             url : "realEstate/p1.jpg"
    //         },
    //         {
    //             url : "realEstate/p2.jpg"
    //         },
    //         {
    //             url : "realEstate/p3.jpg"
    //         },
    //         {
    //             url : "realEstate/p4.jpg"
    //         },
    //         {
    //             url : "realEstate/p5.jpg"
    //         },
    //     ],
    //     icon : 'material-symbols:real-estate-agent-outline'
    // },

    {
        title : 'Construction',
        nick_title : 'construction',
        punch_line : 'Wellcome To Our Classical Construction Services',
        cover_photo : 'Construction/construcion-default.jpg',
        category :[
            {
                title : 'Apartments',
                nick_title : 'apartments',
                content : {
                    companyName : "",
                    paragraph : [
                        {
                            para : 'Welcome to a world of elevated living. Explore the gallery of "Project 4.0" and discover the exceptional features that set us apart. From state-of-the-art kitchens to luxurious amenities, your dream home awaits.',
                        },
                    ]
                },
                cover_photo : 'Construction/Apartments/apartments.jpg',
                photos : [
                    {
                        url : "Construction/Apartments/p1.jpg"
                    },
                    {
                        url : "Construction/Apartments/p2.jpg"
                    },
                    {
                        url : "Construction/Apartments/p3.jpg"
                    },
                    {
                        url : "Construction/Apartments/p4.jpg"
                    }
                ]
            }
        ],
        content1 : "We don't just build structures, we build futures.",
        content2 : "Quad City Estate Pvt.Ltd. will ensure your project is overseen by qualified and licensed civil engineers. They'll handle the design, structural analysis, and ensure compliance with local building codes. We'll integrate innovative robotics to enhance efficiency and safety. Robots can efficiently move heavy materials, reducing strain on workers. Precisely pinpoints the location (GPS) and creates a digital map for accurate planning. Analyzes soil composition and stability to ensure a solid foundation. By combining these elements, Quad City Estate Pvt.Ltd. offers a comprehensive approach to construction.  We'll leverage the expertise of certified engineers, the power of robotics, and the dedication of skilled labor to ensure your project is built on a solid foundation, in the exact location you need, while maximizing efficiency and safety.",
        photos : [
            {
                url : "Construction/flat/flat.jpg"
            },
            // {
            //     url : "Construction/flat/flat.jpg"
            // },
            // {
            //     url : "Construction/p3.jpg"
            // },
            // {
            //     url : "Construction/p4.jpg"
            // },
            // {
            //     url : "Construction/p5.jpg"
            // },
        ],
        icon : 'carbon:construction'
    },

    // {
    //     title : 'Materials Inc',
    //     nick_title : 'materials',
    //     category :[],
    //     content : 'S. S. Civil Construction Pvt. Ltd. (formerly S. S. Construction)was founded in 1984 as contracting company in Civil Construction and Structural Engineering. Some of the most outstanding projects we have executed are Construction of Water Treatment Plant at Chitpur for Eastern Railway; Construction of Kolkata Station Building and its Circulating .',
    //     photos : [
    //         {
    //             url : "materials/p1.jpg"
    //         },
    //         {
    //             url : "materials/p2.jpg"
    //         },
    //         {
    //             url : "materials/p3.jpg"
    //         },
    //         {
    //             url : "materials/p4.jpg"
    //         },
    //         {
    //             url : "materials/p5.jpg"
    //         },
    //     ],
    //     icon : 'lets-icons:materials'
    // },

    {
        title : 'Import-Export',
        nick_title : 'import-export',
        punch_line : 'Wellcome To Our World Class Import-Export Services',
        cover_photo : 'import_export/import-export-default.jpg',
        category :[
            {
                title : 'Vegetable',
                nick_title : 'vegetavle',
                content : {
                    companyName : "",
                    paragraph : [
                        {
                            para : "Quad City Estate Pvt.Ltd. is your gateway to a world of vibrant, fresh vegetables. We connect farmers and consumers across the globe, ensuring a seamless journey for the finest produce. We meticulously source high-quality vegetables from trusted growers around the world, ensuring they meet the strictest standards for freshness, safety, and taste."
                        },
                        {
                            para : "Our experienced team navigates the complexities of international import, handling all logistics to get your vegetables from farm to destination efficiently."
                        }
                    ]
                },
                cover_photo : 'import_export/vegetable/vegetables.jpg',
                photos : [
                    {
                        name : '',
                        url : "import_export/vegetable/p1.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/vegetable/p2.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/vegetable/p3.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/vegetable/p4.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/vegetable/p5.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/vegetable/p6.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/vegetable/p7.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/vegetable/p8.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/vegetable/p9.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/vegetable/p10.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/vegetable/p11.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/vegetable/p12.jpg"
                    },
                ]
            },
            {
                title : 'Fruits',
                nick_title : 'fruits',
                content : {
                    companyName : "",
                    paragraph : [
                        {
                            para : "While not all fruits are involved in international trade, Quad City Estate Pvt.Ltd. can still be your partner for those that are. We can assist with the import and export of a variety of fruits, ensuring they reach their destination fresh and delicious."
                        },
                    ]
                },
                cover_photo : 'import_export/fruits/fruits.jpg',
                photos : [
                    {
                        name : '',
                        url : "import_export/fruits/p1.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/fruits/p2.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/fruits/p3.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/fruits/p4.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/fruits/p5.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/fruits/p6.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/fruits/p7.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/fruits/p8.jpg"
                    },
                ]
            },
            {
                title : 'Fish',
                nick_title : 'fish',
                content : {
                    companyName : "",
                    paragraph : [
                        {
                            para : "At Quad City Estate Pvt.Ltd., we connect you with the vibrant flavors of the Indian coast. We specialize in the import and export of fresh, high-quality fish sourced from the renowned fishing grounds of Digha, Puri, and the Sundarbans, and even the bustling harbor of Mumbai."
                        },
                        {
                            heading : "Mumbai :",
                            para : "A melting pot of flavors, Mumbai's harbor offers a bounty of seafood, from Bombay Duck to Indian Salmon and a variety of shellfish."
                        },
                        {
                            heading : "Digha :",
                            para : "Known for its white pomfret, hilsa, prawns, and crabs, Digha offers a bounty of delicious seafood."
                        },
                        {
                            heading : "Puri :",
                            para : "Famed for its succulent prawns, lobsters, and a variety of shellfish, Puri's fresh catch is a seafood lover's delight."
                        },
                        {
                            heading : "Sundarbans :",
                            para : "This unique ecosystem provides a habitat for a diverse range of fish, including the highly sought-after tiger prawns, hilsa, and a variety of freshwater fish species."
                        },
                        {
                            para : "Partner with Quad City Estate Pvt.Ltd. and embark on a journey of exquisite taste. We are your gateway to delivering the freshness and diversity of Indian seafood to the world."
                        }
                    ]
                },
                cover_photo : 'import_export/fish/fish.jpg',
                photos : [
                    {
                        name : '',
                        url : "import_export/fish/p1.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/fish/p2.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/fish/p3.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/fish/p4.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/fish/p5.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/fish/p6.jpg"
                    },
                ]
            },
            {
                title : 'Spices',
                nick_title : 'spices',
                content : {
                    companyName : "",
                    paragraph : [
                        {
                            para : "Quad City Estate Pvt.Ltd. takes you on a culinary adventure to the heart of South India, the cradle of some of the world's most coveted spices. We are your trusted partner in the import and export of these aromatic treasures."
                        },
                        {
                            heading : "Cardamom, Black Pepper, Cloves, Cinnamon, Chilies, Turmeric",
                            para : "and many more diverse collection of south Indian spices."
                        },
                        {
                            para : "Experience the magic of South Indian spices with Quad City Estate Pvt.Ltd. Let us elevate your culinary creations and connect you with the world's most vibrant flavors."
                        }
                    ]
                },
                cover_photo : 'import_export/spices/spices.jpg',
                photos : [
                    {
                        name : '',
                        url : "import_export/spices/p1.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/spices/p2.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/spices/p3.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/spices/p4.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/spices/p5.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/spices/p6.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/spices/p7.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/spices/p8.jpg"
                    },
                ]
            },

            {
                title : 'Rice',
                nick_title : 'rice',
                content : {
                    companyName : "",
                    paragraph : [
                        {
                            para : "At Quad City Estate Pvt.Ltd., we are passionate about connecting the world with the finest Indian rice varieties, particularly the aromatic basmati and the exquisite sona mukhi. We serve as your trusted partner in the import and export of these culinary treasures."
                        },
                        {
                            heading : "Basmati :",
                            para : 'The "Queen of Fragrant Rice," basmati is known for its long, slender grains that elongate further upon cooking. Its delicate aroma and subtle nutty flavor enhance any dish.',
                        },
                        {
                            heading : "Sona Masoori :",
                            para : 'Also known as "golden pearl," sona masoori rice is prized for its pearly white grains, exceptional aroma, and slightly sweet taste. It cooks to a fluffy texture, perfect for biryani and other delicacies.',
                        },
                        {
                            para : "Choose Quad City Estate Pvt.Ltd. to embark on a journey of exquisite taste. We are your gateway to cultivating a global appreciation for the legacy of Indian rice."
                        }
                    ]
                },
                cover_photo : 'import_export/Rice/p1.jpg',
                photos : [
                    {
                        name : '',
                        url : "import_export/Rice/p1.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/Rice/p2.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/Rice/p3.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/Rice/p4.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/Rice/p5.jpg"
                    },
                ]
            },

            {
                title : 'Pulses',
                nick_title : 'pulses',
                content : {
                    companyName : "",
                    paragraph : [
                        {
                            para : "Quad City Estate Pvt.Ltd. is your one-stop shop for facilitating the global trade of pulses, those essential sources of plant-based protein. We connect farmers, distributors, and consumers worldwide, ensuring a seamless journey for these nutritious and versatile legumes."
                        },
                        {
                            heading : "Chickpeas (Kabuli Chana), Lentils (Masoor Dal, Red Lentil), Pigeon Peas (Tur or Arhar Dal), Mung Beans (Green Gram), Urad Dal (Split Black Gram)",
                            para : "and many more!"
                        },
                        {
                            para : "Partner with Quad City Estate Pvt.Ltd. and become a part of a global movement promoting healthy and sustainable food consumption. Let's bridge the gap and nourish the world together with the power of pulses!"
                        }
                    ]
                },
                cover_photo : 'import_export/Pulses/p1.jpg',
                photos : [
                    {
                        name : '',
                        url : "import_export/Pulses/p1.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/Pulses/p2.jpg"
                    },
                    {
                        name : '',
                        url : "import_export/Pulses/p3.jpg"
                    },
                ]
            },
        ],
        content1 : "Where Borders Blur and Opportunities Bloom.",
        content2 : "Geography won't hold you back. Quad City Estate Pvt.Ltd. connects communities and businesses, building the transportation infrastructure that fuels progress and prosperity across worldwide.",
        photos : [
            {
                url : "import_export/fruits/p1.jpg"
            },
            {
                url : "import_export/vegetable/p2.jpg"
            },
            {
                url : "import_export/fish/p3.jpg"
            },
            {
                url : "import_export/spices/p4.jpg"
            },
        ],
        icon : 'ic:baseline-import-export'
    },

    // {
    //     title : 'Exhibition',
    // nick_title : 'exhibition',
    //     category :[],
    //     content : 'S. S. Civil Construction Pvt. Ltd. (formerly S. S. Construction)was founded in 1984 as contracting company in Civil Construction and Structural Engineering. Some of the most outstanding projects we have executed are Construction of Water Treatment Plant at Chitpur for Eastern Railway; Construction of Kolkata Station Building and its Circulating .',
    //     photos : [
    //         {
    //             url : "Exhibition/p1.jpg"
    //         },
    //         {
    //             url : "Exhibition/p2.jpg"
    //         },
    //         {
    //             url : "Exhibition/p3.jpg"
    //         },
    //         {
    //             url : "Exhibition/p4.jpg"
    //         },
    //         {
    //             url : "Exhibition/p5.jpg"
    //         },
    //     ],
    //     icon : ''
    // }
]



